<div
  class="customer-history-panel position-absolute history z-1 translate-middle-x start-50 border rounded-2"
  data-cy="historic-view-dialog"
>
  <div class="position-relative d-flex align-items-center gap-3 p-3">
    <span
      class="customer-history-close rb-ic rb-ic-close fs-lg position-absolute top-1 end-1 cursor-pointer hover-effect"
      (click)="handleOnHistoryClosed()"
    ></span>
    <ng-container *ngIf="zoomLevelAllowedForHistory()">
      <app-datetime-picker
        [datetime]="currentTimestamp()?.toISOString()"
        (datetimeChanged)="handleOnTimestampChanged($event)"
        [disabled]="isLoading()"
        [step]="1"
      >
      </app-datetime-picker>
      <div
        data-cy="historic-view-reload-button"
        class="customer-history-reload d-flex position-relative align-self-stretch align-items-center btn"
        (click)="handleReloadClick()"
      >
        <span
          class="customer-history-reload-label fs-sm"
          [class.customer-history-reload-label-loading]="isLoading()"
          >Reload</span
        >
        <div class="position-absolute translate-middle start-50 top-50">
          <div
            class="customer-history-spinner spinner-border spinner-border-sm"
            [class.d-none]="!isLoading()"
            role="status"
          ></div>
        </div>
      </div>
      <app-range-picker
        [timespan]="currentTimespan()"
        [timestamp]="currentTimestamp()"
        (timeSpanToggled)="handleOnTimeSpanChanged($event)"
        [disabled]="isLoading()"
        [step]="1"
      >
      </app-range-picker>
    </ng-container>

    <ng-container *ngIf="!zoomLevelAllowedForHistory()">
      <div class="d-flex align-items-center gap-1 p-2">
        <span class="rb-ic rb-ic-alert-info text-warning fs-xl"></span>
        <span class="customer-history-hint fs-sm"
          >To get historic data, zoom in to level {{ config.history_min_zoom_level }}</span
        >
      </div>
    </ng-container>
  </div>
</div>
